module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "absolute",
      "z-index": "5"
    }
  }, [_c('svg', {
    key: _vm.hoverableId,
    ref: _vm.hoverableId,
    staticClass: "hoverable-svg",
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "id": _vm.hoverableId,
      "width": "100%",
      "height": "100%",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    },
    on: {
      "mousemove": _vm.updateCoordinates,
      "click": _vm.handleClickOnSVG
    }
  }, _vm._l((_vm.hoverableItems), function(hoverable) {
    return (!hoverable.hasOwnProperty('scenes') || hoverable.scenes.indexOf(_vm.scene) !== -1) ? _c('g', [(hoverable.hasOwnProperty('points')) ? _c('polygon', {
      staticClass: "hoverable",
      class: {
        'disabled': hoverable.disabled,
          'no-highlight': hoverable.disabled || hoverable.noHover,
          'no-active': hoverable.disabled || hoverable.noActive,
          'debug': hoverable.debug || _vm.debug
      },
      attrs: {
        "points": hoverable.points,
        "id": hoverable.id,
        "transform": hoverable.transform
      },
      on: {
        "mouseover": function($event) {
          _vm.handleMouseOver(hoverable, $event)
        },
        "mouseout": function($event) {
          _vm.handleMouseOut(hoverable, $event)
        },
        "click": function($event) {
          _vm.handleHoverableClick(hoverable, $event)
        }
      }
    }) : (hoverable.hasOwnProperty('circle')) ? _c('circle', {
      staticClass: "hoverable",
      class: {
        'disabled': hoverable.disabled,
          'no-highlight': hoverable.disabled || hoverable.noHover,
          'no-active': hoverable.disabled || hoverable.noActive,
          'debug': hoverable.debug || _vm.debug
      },
      attrs: {
        "cx": hoverable.circle.cx,
        "cy": hoverable.circle.cy,
        "r": hoverable.circle.r,
        "id": hoverable.id,
        "transform": hoverable.transform
      },
      on: {
        "mouseover": function($event) {
          _vm.handleMouseOver(hoverable, $event)
        },
        "mouseout": function($event) {
          _vm.handleMouseOut(hoverable, $event)
        },
        "click": function($event) {
          _vm.handleHoverableClick(hoverable, $event)
        }
      }
    }) : (hoverable.hasOwnProperty('ellipse ')) ? _c('ellipse', {
      staticClass: "hoverable",
      class: {
        'disabled': hoverable.disabled,
          'no-highlight': hoverable.disabled || hoverable.noHover,
          'no-active': hoverable.disabled || hoverable.noActive,
          'debug': hoverable.debug || _vm.debug
      },
      attrs: {
        "cx": hoverable.ellipse.cx,
        "cy": hoverable.ellipse.cy,
        "rx": hoverable.ellipse.rx,
        "ry": hoverable.ellipse.ry,
        "id": hoverable.id,
        "transform": hoverable.transform
      },
      on: {
        "mouseover": function($event) {
          _vm.handleMouseOver(hoverable, $event)
        },
        "mouseout": function($event) {
          _vm.handleMouseOut(hoverable, $event)
        },
        "click": function($event) {
          _vm.handleHoverableClick(hoverable, $event)
        }
      }
    }) : (hoverable.hasOwnProperty('rect')) ? _c('rect', {
      staticClass: "hoverable",
      class: {
        'disabled': hoverable.disabled,
          'no-highlight': hoverable.disabled || hoverable.noHover,
          'no-active': hoverable.disabled || hoverable.noActive,
          'debug': hoverable.debug || _vm.debug
      },
      attrs: {
        "x": hoverable.rect.x,
        "y": hoverable.rect.y,
        "rx": hoverable.rect.rx,
        "ry": hoverable.rect.ry,
        "height": hoverable.rect.height,
        "width": hoverable.rect.width,
        "id": hoverable.id,
        "transform": hoverable.transform
      },
      on: {
        "mouseover": function($event) {
          _vm.handleMouseOver(hoverable, $event)
        },
        "mouseout": function($event) {
          _vm.handleMouseOut(hoverable, $event)
        },
        "touchstart": function($event) {
          _vm.handleTouchStart(hoverable, $event)
        },
        "click": function($event) {
          _vm.handleHoverableClick(hoverable, $event)
        }
      }
    }) : (hoverable.hasOwnProperty('d')) ? _c('path', {
      staticClass: "hoverable",
      class: {
        'disabled': hoverable.disabled,
          'no-highlight': hoverable.disabled || hoverable.noHover,
          'no-active': hoverable.disabled || hoverable.noActive,
          'debug': hoverable.debug || _vm.debug
      },
      attrs: {
        "d": hoverable.d,
        "id": hoverable.id,
        "transform": hoverable.transform
      },
      on: {
        "mouseover": function($event) {
          _vm.handleMouseOver(hoverable, $event)
        },
        "mouseout": function($event) {
          _vm.handleMouseOut(hoverable, $event)
        },
        "click": function($event) {
          _vm.handleHoverableClick(hoverable, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.getAppLevelSetting('debug') === true) ? _c('text', {
      attrs: {
        "x": _vm.getFirstXY(hoverable)[0],
        "y": _vm.getFirstXY(hoverable)[1],
        "font-family": "Verdana",
        "font-size": "25",
        "fill": "purple",
        "text-anchor": "middle"
      }
    }, [_vm._v(_vm._s(hoverable.linkTo))]) : _vm._e()]) : _vm._e()
  })), _vm._v(" "), (false) ? _c('section', [_c('p', {
    staticStyle: {
      "color": "white",
      "font-size": "30px",
      "z-index": "5",
      "position": "absolute",
      "bottom": "0px"
    },
    attrs: {
      "id": "coords"
    },
    on: {
      "click": _vm.printCoord
    }
  }, [_vm._v(_vm._s(_vm.coords))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "white",
      "font-size": "30px",
      "z-index": "5",
      "position": "absolute",
      "bottom": "0px",
      "right": "0px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.x) + "," + _vm._s(_vm.y))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-777e757c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hoverable-SVG.vue
// module id = 231
// module chunks = 1